// Atributos de contacto marcados para sincronizar con etiquetas.
//
// Son los que la cuenta usa como clasificación del contacto (Tipo, Estado y
// los que añada), así que son los que merecen un filtro propio en las
// cabeceras. Se devuelven en el orden configurado, el mismo que usa
// `groupLabelsByCustomAttribute` para agrupar las etiquetas.
export const syncedListAttributes = (attributes = []) =>
  attributes
    .filter(
      attribute =>
        attribute.syncWithLabels &&
        attribute.attributeDisplayType === 'list' &&
        (attribute.attributeValues || []).length > 0
    )
    .toSorted(
      (a, b) =>
        (a.displayOrder ?? Number.MAX_SAFE_INTEGER) -
          (b.displayOrder ?? Number.MAX_SAFE_INTEGER) || a.id - b.id
    );
